import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UsersAuthService } from "src/app/users-auth.service";
import { ApiService } from "../../../Services/api.service";
import { NotificationService } from "../../../Services/notification.service";
import { HttpClient } from '@angular/common/http';
import { trigger, transition, style, animate } from '@angular/animations';
import { ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map, distinctUntilChanged } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'notifications-cmp',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  animations: [
    trigger('fadeOut', [ // ya existente
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateX(50px)' }))
      ])
    ]),

    // NUEVO trigger solo para el modal
    trigger('fadeModal', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate('250ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
      ])
    ])
  ]


})
export class NotificationsComponent implements OnInit {

  userID: number;
  userRole: number;
  notifications: any;
  notificationHistory: any[] = [];
  now: Date = new Date();
  selectedTabIndex: number = 0;
  filteredNotifications: any[] = [];
  showModal: boolean = false;
  pendingModalNotifications: any[] = [];
  currentModalNotification: any = null;
  modalKey: string = '';
  private routerSub: any;
  private refreshSub: Subscription;
  // Tracks pending (unacknowledged) IDs that have already triggered a sound, to avoid repeating it
  private knownPendingIds = new Set<number>();

  constructor(private apiService: ApiService, private http: HttpClient, private userAuth: UsersAuthService, private _notificationService: NotificationService, private router: Router, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('SessionMAO'));
    this.userID = user.UserID;
    this.userRole = user.RoleID;

    this.routerSub = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map((event: NavigationEnd) => event.urlAfterRedirects),
        distinctUntilChanged(),                                   // Avoids repeated events from the same URL
        filter(url => url !== '/pages/login')
      )
      .subscribe(() => {
        this.getUserNotifications();
      });

    // After login immediate load (only once)
    this.getUserNotifications();

    // 2026-03-02 JBDCR: Refresh notifications when a polled report request completes.
    this.refreshSub = this._notificationService.refreshNotifications$.subscribe(() => {
      this.getUserNotifications();
    });
  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  };

  getUserNotifications = async () => {
    // Avoid calls during logout/transitions or if there is no valid session
    if (!this.userAuth || !this.userAuth.isAuthenticated()) {
      return;
    }

    // Always re-read the current session before requesting notifications
    const s = JSON.parse(localStorage.getItem('SessionMAO'));
    if (s) {
      this.userID = s.UserID;
      this.userRole = s.RoleID;
    }

    await this._notificationService.getNotificationToDisplay(this.userID, this.userRole)
      .then((resp: any) => {
        if (resp.code === 200) {
          this.notifications = resp.Value || [];
          // Stamp safe HTML once so templates use safeContent instead of raw AlertContent
          this.notifications.forEach(n => {
            const parsed = this.tryParseNotificationContent(n.AlertContent);
            if (parsed) {
              n.parsedSummary = parsed.Summary || null;
              n.parsedActions = (parsed.Actions || []).map((action: any) => ({
                ...action,
                safeIcon: this.sanitizer.bypassSecurityTrustHtml(action.Icon || '')
              }));
              n.safeContent = this.sanitizer.bypassSecurityTrustHtml(parsed.Content || '');
            } else {
              n.parsedSummary = null;
              n.parsedActions = [];
              n.safeContent = this.sanitizer.bypassSecurityTrustHtml(n.AlertContent || '');
            }
          });

          // 1. Filter the ones that have not been acknowledged (without DateAcknowledge)
          const pendingNotifications = this.notifications.filter(n => !n.DateAcknowledge);

          // Play sound for any pending ID not yet seen — includes first load (login)
          const hasNewPending = pendingNotifications.some(n => !this.knownPendingIds.has(n.AlertID));
          if (hasNewPending) {
            this.playBellSound();
          }
          pendingNotifications.forEach(n => this.knownPendingIds.add(n.AlertID));

          // 2. Sort by priority: Critical (2) > Warning (3) > Information (1)
          const priority = { 2: 0, 3: 1, 1: 2 };
          pendingNotifications.sort((a, b) => {
            const aPriority = priority[a.AlertTypeID] !== undefined ? priority[a.AlertTypeID] : 3;
            const bPriority = priority[b.AlertTypeID] !== undefined ? priority[b.AlertTypeID] : 3;
            return aPriority - bPriority;
          });

          // 3. Saves the list and shows the modal
          this.pendingModalNotifications = pendingNotifications;
          this.showModal = pendingNotifications.length > 0;
          if (this.showModal) {
            this.loadNextNotificationModal();
          }

          // 4. Build tray
          this.buildNotificationTray(this.notifications);
        }
      })
      .catch(err => console.log(err));
  };


  // Function to show all pending notifications, one after another
  loadNextNotificationModal() {
    if (this.pendingModalNotifications.length === 0) {
      this.showModal = false;
      return;
    }

    this.currentModalNotification = this.pendingModalNotifications[0];
    this.showModal = true;
    this.updateNotificationDisplayDate(this.currentModalNotification.AlertID, this.userID);

    // Fuerza un cambio de "clave" para que Angular destruya y cree el DOM del modal
    this.modalKey = `${this.currentModalNotification.AlertID}-${new Date().getTime()}`;
  }


  acknowledgeAndNext() {
    if (!this.currentModalNotification) return;

    this.markNotificationAsAcknowledged(this.currentModalNotification.AlertID, this.userID);

    this.pendingModalNotifications.shift();

    this.showModal = false; // dispara la animación de salida

    setTimeout(() => {
      this.loadNextNotificationModal(); // espera y carga siguiente
    }, 220); // espera ligeramente más que la animación `:leave`
  }

  closeModal() {
    this.pendingModalNotifications.shift();

    this.showModal = false;

    setTimeout(() => {
      this.loadNextNotificationModal();
    }, 220);
  }


  markNotificationAsAcknowledged = async (alertID: number, userID: number) => {
    await this._notificationService.markNotificationAsAcknowledged(alertID, userID)
      .then((resp: any) => {
      })
      .catch(err => console.log(err));
  }

  updateNotificationDisplayDate = async (alertID: number, userID: number) => {
    await this._notificationService.updateNotificationDisplayDate(alertID, userID)
      .then((resp: any) => {
        // Handle successful response
      })
      .catch(err => console.log(err));
  }

  markNotificationsAsDismissed = async (alertIDs: number[], userID: number) => {
    await this._notificationService.markNotificationsAsDismissed(alertIDs, userID)
      .then((resp: any) => {
        if (resp.code === 200) {
          this.notificationHistory = this.notificationHistory.filter(
            n => !alertIDs.includes(n.AlertID)
          );
        }
      })
      .catch(err => console.log(err));
  }

  onClearAllNotifications() {
    const alertIDs = this.notificationHistory.map(n => n.AlertID);
    // Mark all as "isDismissing" to activate the animation
    this.notificationHistory.forEach(n => n.isDismissing = true);
    // Call the backend
    this._notificationService.markNotificationsAsDismissed(alertIDs, this.userID)
      .then(() => {
        // Wait for the animation to finish before clearing the array
        setTimeout(() => {
          this.notificationHistory = [];
          this.filterNotificationsByTab(); // Ensure filteredNotifications is also cleared
        }, 220); // A little more than the animation (200ms)
      })
      .catch(err => console.log(err));
  }

  onDeleteNotification(event: MouseEvent, alertID: number, userID: number) {
    event.stopPropagation();
    event.preventDefault();
    // Mark as "dismissed" in the backend
    const notif = this.notificationHistory.find(n => n.AlertID === alertID);
    if (notif) {
      notif.isDismissing = true;
      this._notificationService.markNotificationsAsDismissed([alertID], userID)
        .catch(err => console.log(err));
      // Now, after X ms (equal to the duration of the animation), remove it from the array
      setTimeout(() => {
        this.notificationHistory = this.notificationHistory.filter(n => n.AlertID !== alertID);
      }, 220); // A little more than configured in animate('200ms')
    }
  }

  buildNotificationTray(notifications: any[]) {
    this.notificationHistory = [];

    if (notifications && notifications.length > 0) {
      notifications.forEach(element => {
        // Only add if DateDismiss is null
        if (!element.DateDismiss) {
          this.notificationHistory.push(element);
        }
      });
    }
    this.filterNotificationsByTab();
  }

  onTabChange(index: number) {
    this.selectedTabIndex = index;
    this.filterNotificationsByTab();
  }

  filterNotificationsByTab() {
    switch (this.selectedTabIndex) {
      case 1: // Critical
        this.filteredNotifications = this.notificationHistory.filter(n => n.AlertTypeID === 2);
        break;
      case 2: // Informative
        this.filteredNotifications = this.notificationHistory.filter(n => n.AlertTypeID === 1);
        break;
      case 3: // Warning
        this.filteredNotifications = this.notificationHistory.filter(n => n.AlertTypeID === 3);
        break;
      default: // All
        this.filteredNotifications = this.notificationHistory;
        break;
    }
  }

  // 2026-03-03 JBDCR: Plays the notification sound for new pending (unacknowledged) notifications.
  private playBellSound(): void {
    try {
      const audio = new Audio('https://adoptimizerapiresultssto.blob.core.windows.net/maojsfiles-test/assets/notification_sound.mp3');
      audio.play().catch(() => { /* Autoplay blocked by browser policy */ });
    } catch (e) { /* Audio not supported */ }
  }

  private tryParseNotificationContent(content: string): { Summary?: string; Content?: string; Actions?: any[] } | null {
    if (!content) return null;
    try {
      const trimmed = content.trim();
      if (!trimmed.startsWith('{')) return null;
      return JSON.parse(trimmed);
    } catch {
      return null;
    }
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
      this.routerSub = null;
    }
    if (this.refreshSub) {
      this.refreshSub.unsubscribe();
    }
  }

}
